module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "fm01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page06"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page07"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber"
  }, [_c('span', {
    staticClass: "xrefInternal"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#fm_01"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("prologue")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/07.jpg"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page08"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "chapterOpenerText"
  }, [_c('span', {
    staticClass: "chapterOpenerFirstWords"
  }, [_vm._v("In the darkness,")]), _vm._v(" it moved, searching for something tactile.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Sensing the way, following its instincts. For instinct was almost all it had left.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Somewhere, sometime, some-"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("when")]), _vm._v(" it had possessed identity. It had the characteristics and physicality that bound it to a world. But those were gone now. Now it was little more than an urge: a bundled collection of needs with the barest hint of form.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("But the void around it possessed even less form.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("It knew that somewhere within this void lay the thing it sought, and so it kept moving.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("And as it moved, unfamiliar features inside it sprang to life. In a hidden fold of its being arose a thing called “language.” With that came knowledge, and consciousness. Its journey deepened.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("It passed through a cloud of something it could now call “sadness” and wept. It passed through “serenity” and its calm returned.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Something inside it prickled. What it sought was near. Moving toward it, pushing with all its might. The prickling increased, rushing through it like a torrent of needles.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("It reveled in this sensation, for it signaled that the end of its journey was near.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("And even as this thought formed, its journey "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("did")]), _vm._v(" end. It had reached its destination. As it basked in this victory, a new word appeared: the name for this thing it had sought so desperately, so diligently, and for so long.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The word was…"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("radio")]), _vm._v(".")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page09"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33bfd489","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/prologue.vue
// module id = 72
// module chunks = 0